import { createTheme } from '@mui/material/styles';

const cyberLight = {
  palette: {
    mode: 'light',
    primary: { main: '#00CFFF' }, // neón suave día
    secondary: { main: '#FF3FA3' },
    accent: { main: '#FFB800' },
    background: { default: '#F5F7FA', paper: 'rgba(255,255,255,0.9)' },
    text: { primary: '#0A0A0A', secondary: '#4A4A4A' },
  },
  typography: {
    fontFamily: `'Outfit', 'Inter', sans-serif`,
    h1: { fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontWeight: 700, letterSpacing: '-0.01em' },
  },
  shape: { borderRadius: 16 },
};

const cyberDark = {
  palette: {
    mode: 'dark',
    primary: { main: '#00F5FF' },
    secondary: { main: '#FF00C1' },
    accent: { main: '#FFD700' },
    background: { default: '#0D0D1A', paper: 'rgba(13,13,26,0.85)' },
    text: { primary: '#E0E0E0', secondary: '#A0A0A0' },
  },
  typography: {
    fontFamily: `'Outfit', 'Inter', sans-serif`,
    h1: { fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontWeight: 700, letterSpacing: '-0.01em' },
  },
  shape: { borderRadius: 16 },
};

export const createAppTheme = (mode) => createTheme(mode === 'light' ? cyberLight : cyberDark);
